/**
 * L'Invoice project translations - Tooltips section
 */

const tooltips = {
  // Bulk actions - Documents
  selectMultipleDocumentsForGroupActions: "Select two or more documents to enable group actions.",
  // Bulk actions - E-Documents
  selectMultipleDocumentsForPeppol: "Select two or more documents to enable bulk send actions.",
  moveToDocumentsCurrentPageOnly:
    "Move to Documents is only available when your selection is limited to the current page (not “all pages”).",
  // Settings
  changeStatus: "Change Status",
};

export default tooltips;
